<!-- 记账本-记账详情 -->
<template>
  <div class="accountbook-detail" data-test="accountbook-detail">
    <div class="wrap">
      <div class="wrap-top">
        <van-icon
          class="icon"
          :class="{ income: detail.incomePayType == 0 }"
          class-prefix="vxs-icon"
          :name="`${
            accountIconMap[detail.accTypeCode || detail.incomePayType]
          }`"
          size="32"
        ></van-icon>
        <div class="name">{{ detail.accountTypeName }}</div>
        <div class="count">
          {{ detail.incomePayType == 0 ? "+" : "-" }}
          {{ detail.amount | formatNumber }}
        </div>
      </div>
      <div class="split van-hairline--bottom"></div>
      <div class="item-box">
        <div class="item">
          <span class="label">计入校区</span>
          <div class="content">{{ detail.campusName }}</div>
        </div>
        <div class="item">
          <span class="label">来源</span>
          <div class="content">
            {{ detail.source == 0 ? "手工记账" : "自动记账" }}
          </div>
        </div>
        <div class="item">
          <span class="label">记账人</span>
          <div class="content">{{ detail.bookKeeperName }}</div>
        </div>
        <div class="item">
          <span class="label">记账时间</span>
          <div class="content">
            {{ detail.accountTime | formatDatetime("yyyy-MM-dd") }}
          </div>
        </div>
        <div class="item">
          <span class="label">备注</span>
          <div class="content">{{ detail.remark }}</div>
        </div>
        <div class="item">
          <span class="label">凭证</span>            
        </div>
        <vx-mult-input-show
              :list="detail.detail && detail.detail.list"
            ></vx-mult-input-show>
      </div>
    </div>
    <page-footer-btn multipleBtns v-if="app.permission.op('delete_account_book || edit_account_book')">
      <van-button 
        square round block 
        @click="del" 
        data-test="accountbook-detail-btn-delete"
        v-if="app.permission.op('delete_account_book')"
      >删除</van-button>
      <van-button 
        square round block 
        type="primary" 
        @click="edit" 
        data-test="accountbook-detail-btn-edit"
        v-if="app.permission.op('edit_account_book')"
        >编辑</van-button>
    </page-footer-btn>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";

export default {
  name: "accountbook-detail",
  data() {
    return {
      pageTitle: "详情",
      accountRecordId: "",
      detail: {},
      accountIconMap: {
        OFFICE_RENTS_SPENDING: "bangongzujin",
        SALARY_SPENDING: "xinzi",
        OTHER_SPENDING: "qitashouzhi",
        1: "zidingyishouzhi",
        OTHER_INCOME: "qitashouzhi",
        0: "zidingyishouzhi",
      },
    };
  },
  methods: {
    render() {
      this.$api
        .getAccountBook({
          accountRecordId: this.accountRecordId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.detail = res.data;
          } else {
            this.$toast.fail(res.msg);
          }
        });
    },
    del() {
      this.$dialog
        .confirm({
          message: "确定删除这条账目么？",
        })
        .then(() => {
          this.$api.deleteAccountBook(this.accountRecordId).then((res) => {
            if (res.code === 200) {
              this.$toast.success("删除成功");
              app.vue.$emit("editOrDel-accountbook-success");
              setTimeout(() => {
                this.$router.back();
              }, 50);
            }
          });
        });
    },
    edit() {
      this.$router.push(
        `/accountbookEdit?type=edit&editType=${this.detail.incomePayType}&editId=${this.accountRecordId}`
      );
    },
  },
  created() {
    this.accountRecordId = this.$route.params.id;
    this.render();

    this.$onBus("refresh-accountbook-detail", () => {
      this.render();
    });
  },
  beforeDestroy() {},
  components: {
    pageFooterBtn,
  },
};
</script>

<style lang="scss" scope>
.accountbook-detail {
  display: flex;
  flex-direction: column;
  .wrap {
    flex: 1;
    overflow-y: auto;
    .wrap-top {
      text-align: center;
      padding: calc(var(--gap) * 40) calc(var(--gap) * 24) calc(var(--gap) * 54) calc(var(--gap) * 24);
      background-color: var(--white);
      .icon {
        color: var(--c1);
        &.income {
          color: var(--c5);
        }
      }
      .name {
        margin: calc(var(--gap) * 13) 0 calc(var(--gap) * 8) 0;
        color: var(--black);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
      }
      .count {
        color: var(--g8);
        font-size: calc(var(--w) * 24);
        line-height: calc(var(--w) * 33);
      }
    }
    .split {
      margin: 0 calc(var(--gap) * 24);
    }
    .item-box {
      padding: calc(var(--gap) * 24);
      background-color: var(--white);
      .item {
        display: flex;
        margin-bottom: calc(var(--gap) * 8);
        color: var(--g8);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        .label {
          display: inline-block;
          width: calc(var(--w) * 80);
          margin-right: calc(var(--gap) * 8);
          color: var(--g7);
          &::after {
            content:"："
          }
        }
        .content {
          flex: 1;
        }
      }
    }
  }
}
</style>